module.exports = __webpack_public_path__ + "static/media/noroot-2.e86b5481.png";